import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AbstractControl } from '@angular/forms/src/model';
import { MatTableDataSource } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,
  IceexpansionpanelSettings,

  iceColumnDefinition,

  SECTION_CONTROL_ALIGNMENT
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../../../../../src/app/app.service';
import { DomainService, IConsentListItem, ConsentListObject } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { MessageService } from 'projects/icemedx-lib/src/services/message/message.service';
import { GoogleService } from 'projects/icemedx-lib/src/services/google/google.service';
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';

import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { message } from 'projects/icemedx-lib/src/models/messages/message';
import { consentreference } from 'projects/icemedx-lib/src/models/domain/consentreference';
import { user } from '../../models/common/user';
import { telehealthtrial } from '../../models/landing/telehealthtrial';
import { managementguideline } from '../../models/ehr/subs/managementguideline';
import { alert } from '../../models/system/alert';

// Placeholders
const EmailOfRecipientPlaceholder: string = "Email of Recipient";
const MemberIDOfRecipientPlaceholder: string = "The Name of the Member to Invite";
const SubjectPlaceholder: string = "Enter Subject";
const MessageBodyPlaceholder: string = "Enter Message";

// Fields
const TypeOfInvite: string = "TypeOfInvite";
const Recipient: string = "Recipient";
const RecipientTitle: string = "RecipientTitle";
const RecipientFirstname: string = "RecipientFirstname";
const RecipientLastname: string = "RecipientLastname";
const ToRecipient: string = "ToRecipient";
const Subject: string = "Subject";
const MessageBody: string = "MessageBody";
const AgreeToTerms: string = "AgreeToTerms";
const Recaptcha: string = "Recaptcha";

// Panels
const panelTypeOfInvite: string = "TypePanel";
const panelInvite: string = "InvitePanel";
const panelTerms: string = "TermsPanel";
const panelBot: string = "BotPanel";

enum typeOfMember {
  toiNew = 0,
  toiExisting = 1
}

@Component({
  selector: 'invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss'],
  providers: [AppService]
})
export class InviteComponent implements OnInit {
  // Data member
  invitemsg: message = new message();
  defaultConsents: consentreference[] = null;
  consentDataSource: MatTableDataSource<IConsentListItem> = new MatTableDataSource<IConsentListItem>([])

  // Member settings
  inviteSettings: IcepanelcontainerSettings = null;
  btnSendInviteSettings: IcecontrolSettings = new IcecontrolSettings("SendInviteButton", { text: "Send", class: [], glyphClass: "fa-plus-circle" }, null, null);

  // Member controls
  typeOfInviteCtrl: IcecontrolSettings = null;
  recipientCtrl: IcecontrolSettings = null;
  recipientTitleCtrl: IcecontrolSettings = null;
  recipientFirstnameCtrl: IcecontrolSettings = null;
  recipientLastnameCtrl: IcecontrolSettings = null;
  recipientTitleSection: IcepanelsectionSettings = null;

  toRecipientCtrl: IcecontrolSettings = null;
  subjectCtrl: IcecontrolSettings = null;
  messageBodyCtrl: IcecontrolSettings = null;

  agreeToTermsCtrl: IcecontrolSettings = null;

  recaptchaCtrl: IcecontrolSettings = null;
  panels: IcepanelSettings[] = [];

  constructor(private appSvc: AppService,
    private domainSvc: DomainService,
    private navSvc: IceNavService,
    private loginSvc: LoginService,
    private messageService: MessageService,
    private googleService: GoogleService,
    private router: Router,
    private changeDetectorRefs: ChangeDetectorRef) {

    this.appSvc.defaultMenus();
    this.inviteSettings = this.viewSetup();
  }

  viewSetup(): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {

      let panelKey = Iceutility.guid(false);

      /////////////////////////////////////////////////
      // Invite Type
      this.typeOfInviteCtrl = new IcecontrolSettings("iceradiobutton", { width: "250px" }, null, null, TypeOfInvite, "Type of Invite")
        .setControlName(TypeOfInvite)
        .setOptions([
          { id: Iceutility.guid(true), name: "Invite a \"New Network Member\" to my network", value: typeOfMember.toiNew, checked: false },
          { id: Iceutility.guid(true), name: "Invite an \"Existing Network Member\" to my network", value: typeOfMember.toiExisting, checked: true }
        ])
        .createFormControl(typeOfMember.toiExisting, [Validators.required]);

      this.recipientCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "250px" }, null, null, Recipient, MemberIDOfRecipientPlaceholder)
        .setControlName(Recipient)
        .createFormControl("", [Validators.required]);

      let inviteTypeControls: IcecontrolSettings[] = [
        this.typeOfInviteCtrl,
        this.recipientCtrl
      ];

      this.recipientTitleCtrl = new IcecontrolSettings("iceinput", { width: "250px" }, null, null, RecipientTitle, "Title of Invitee. i.e. Mr., Mrs., Ms, or Dr.")
        .setControlName(Recipient)
        .createFormControl("", []);
      this.recipientFirstnameCtrl = new IcecontrolSettings("iceinput", { width: "250px" }, null, null, RecipientFirstname, "First name of Invitee")
        .setControlName(Recipient)
        .createFormControl("", []);
      this.recipientLastnameCtrl = new IcecontrolSettings("iceinput", { width: "250px" }, null, null, RecipientLastname, "Last name of Invitee")
        .setControlName(Recipient)
        .createFormControl("", []);

      let inviteTitleControls: IcecontrolSettings[] = [
        this.recipientTitleCtrl,
        this.recipientFirstnameCtrl,
        this.recipientLastnameCtrl
      ];

      this.recipientTitleSection = new IcepanelsectionSettings("InviteTitleViewSection", { class: ["yalla"], styles: { width: "100%" } }, null, inviteTitleControls, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical).setShow(false);

      let typeOfInviteSections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("InviteTypeViewSection", { class: ["yalla"], styles: { width: "100%" } }, null, inviteTypeControls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
        this.recipientTitleSection
      ];

      /////////////////////////////////////////////////
      // Invitation
      let userInfo = this.loginSvc.GetSessionUserInfo();

      this.toRecipientCtrl = new IcecontrolSettings("icelabel", { value: "To: ", width: "300px", hasFullWidthContainer: false, class: "" }, null, null, ToRecipient)
        .setControlName(ToRecipient)
        .createFormControl("", [Validators.required]);
      this.subjectCtrl = new IcecontrolSettings("iceinput", { width: "250px" }, null, null, Subject, SubjectPlaceholder)
        .setControlName(Subject)
        .createFormControl("", [Validators.required]);
      this.messageBodyCtrl = new IcecontrolSettings("icetextarea", { width: "90%", height: "200px" }, null, null, MessageBody, MessageBodyPlaceholder)
        .setControlName(MessageBody)
        .createFormControl("", [Validators.required]);

      let invitationControls: IcecontrolSettings[] = [
        new IcecontrolSettings("icelabel", { value: "From:" + userInfo.Name, width: "300px", hasFullWidthContainer: false, class: "" }, null, null),
        this.toRecipientCtrl,
        this.subjectCtrl,
        this.messageBodyCtrl
      ];

      let invitationSections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("InviteViewSection", { class: ["yalla"], styles: { width: "100%" } }, null, invitationControls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical)
      ];
      this.subjectCtrl.getFormControl().setValue("Invitation to Collaborate");
      this.messageBodyCtrl.getFormControl().setValue("I would like to invite you to my network.");

      /////////////////////////////////////////////////
      // Terms
      this.agreeToTermsCtrl = new IcecontrolSettings("icecheckbox", { width: "50px", cursor: 'pointer' }, null, null, null)
        .setControlName()
        .createFormControl(false, [Validators.required]); // To do: fix this as it is not working formgroup

      let termsTables: IcemattableSettings[] = [
        new IcemattableSettings(
          "ConsentTable",
          [
            new iceColumnDefinition("full_name", "Name", false, false,
              new IcecontrolSettings("icelabel", { width: "75px", cursor: 'pointer' }, null, null)),
            new iceColumnDefinition("title_of_terms", "Agree To", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("date_of_consent", "Date", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("status", "Status", false),
            new iceColumnDefinition("agree", "Agree", false, false,
              this.agreeToTermsCtrl
            ),
            new iceColumnDefinition("external_data_key", "external_data_key", false, true),
            new iceColumnDefinition("key", "Key", true),
          ],
          this.consentDataSource,
          [],
          false,
          null,
          true
        )
      ];
      let termsGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, termsTables)
      ];

      let termsSections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("TermsSection", { class: [], styles: { width: "100%" } }, termsGroups, [], null)
      ];

      /////////////////////////////////////////////////
      // Not a Bot
      this.recaptchaCtrl = new IcecontrolSettings("icerecaptcha", { width: "50px" }, null, null, Recaptcha)
        .setControlName(Recaptcha)
        .createFormControl(false, [Validators.required]);

      let notABotControls: IcecontrolSettings[] = [
        this.recaptchaCtrl
      ];

      let notABotSections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("NotABotSection", { class: ["yalla"], styles: { width: "100%" } }, null, notABotControls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical)
      ];

      this.panels = [
        new IceexpansionpanelSettings(panelTypeOfInvite, panelKey, "Type of Member to Invite", "", typeOfInviteSections, null, null, null, 0)
          .enableForm(),
        new IceexpansionpanelSettings(panelInvite, panelKey, "Invitation", "", invitationSections, null, null, null, 1)
          .enableForm(),
        new IceexpansionpanelSettings(panelTerms, panelKey, "Terms, Disclosures and Consents", "", termsSections, null, null, null, 2)
          .enableForm(),
        new IceexpansionpanelSettings(panelBot, panelKey, "I am not a Bot", "", notABotSections, null, null, null, 3)
          .enableForm()
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [
        new IcepanelcontainerRowSettings(this.panels)
      ];
      setup = new IcepanelcontainerSettings("InviteViewContainer", panelrows);

      this.getMemberList(); // do the member list since the default type is existing members
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
    this.changeDetectorRefs.detectChanges();

    this.domainSvc.getDefaultConsents().subscribe(
      data => {
        if (data == null) return;

        this.defaultConsents = data;
        let dat: ConsentListObject[] = [];
        for (let i = 0; i < data.length; i++) {
          let cons: consentreference = data[i];
          if (cons == null) continue;

          let fullname = "";
          let memid = "";
          let userInfo = this.loginSvc.GetSessionUserInfo();
          if (userInfo) {
            fullname = userInfo.Name;
            memid = userInfo.Username;
          }
          dat.push(new ConsentListObject(cons.consent_reference_key, cons.external_data_key, memid, fullname, cons.title, "Required"));
        }

        this.consentDataSource.data = dat;
      },
      error => {
        console.log(JSON.stringify(this.domainSvc.getLastErrors()));
      });

  }

  private doRecipientFromControl() {
    let toRecip = "";
    let ctrRecipient: FormControl = this.recipientCtrl.getFormControl();
    if (ctrRecipient != null) {
      if (<typeOfMember>this.typeOfInviteCtrl.getFormControl().value == typeOfMember.toiNew) {
        this.invitemsg.to = this.getRecipientElementValue();
        toRecip = this.invitemsg.to;
      }
      else {
        let selectedRecips = JSON.parse(ctrRecipient.value);
        if (selectedRecips == null || selectedRecips.length == 0) {
          this.invitemsg.to = ctrRecipient.value; // let's try this recipient
          toRecip = this.invitemsg.to;
        }
        else {
          this.invitemsg.to = "";
          if (selectedRecips.length > 1) {
            this.messageService.logMessage(IceTypes.LOGTYPE.ltWarning, "Warning: Only one invited recipient is allowed.");
          }

          this.recipientCtrl.getFormControl().markAsPristine();

          for (let i = 0; i < selectedRecips.length; i++) {
            if (this.invitemsg.to.length > 0) this.invitemsg.to += ",";
            this.invitemsg.to += selectedRecips[i].value;
            toRecip = selectedRecips[i].value + " - " + selectedRecips[i].name;
            break; // only one allowed
          }
        }
      }
    }

    let ctrToRecipient: FormControl = this.toRecipientCtrl.getFormControl();
    if (ctrToRecipient != null) ctrToRecipient.setValue(toRecip);
  }

  onActionClick(event) {
    if (event.headerCtrl != null && event.headerCtrl instanceof IceexpansionpanelSettings) {
      let panel: IcepanelSettings = event.headerCtrl;
      let form: FormGroup = panel.getForm();
      if (form == null || false == form.valid) {

        if (panel.tag != panelTypeOfInvite) {
          if (panel.tag == panelInvite && this.validateRecipient()) // check and log mesage for user
            this.doRecipientFromControl();
        }
        return;
      }

      switch (panel.tag) {
        case panelTypeOfInvite: {
          if (this.validateRecipient()) {
            this.doRecipientFromControl();
          }
          break;
        }
        case panelInvite: {
          let ctrSub: FormControl = this.subjectCtrl.getFormControl();
          if (ctrSub != null) this.invitemsg.subject = ctrSub.value;

          let ctrMsg: FormControl = this.messageBodyCtrl.getFormControl();
          if (ctrMsg != null) this.invitemsg.message_body = ctrMsg.value;
          break;
        }
        case panelTerms: {
          break;
        }
        case panelBot: {
          break;
        }
      }
    }
  }

  onControlChange(event) {
    if (Iceutility.isdefined(event.buttonSettings)) {
      switch (event.buttonSettings.id) {
        case TypeOfInvite: {
          if (Iceutility.isdefined(event.value)) {
            let frmCtrl = this.recipientCtrl.getFormControl();
            if (event.value == typeOfMember.toiNew) {
              this.recipientCtrl.getFormControl().reset();
              this.recipientCtrl.placeholder = EmailOfRecipientPlaceholder;
              this.recipientCtrl.setOptions([]);
              if (frmCtrl) {
                frmCtrl.clearValidators();
                frmCtrl.setValidators([Validators.required, Validators.email]);
                frmCtrl.markAsPristine();
                frmCtrl.setValue("");
                frmCtrl.updateValueAndValidity();
              }

              this.recipientTitleSection.setShow(true);
              this.recipientTitleCtrl.getFormControl().setValidators([Validators.required]);
              this.recipientFirstnameCtrl.getFormControl().setValidators([Validators.required]);
              this.recipientLastnameCtrl.getFormControl().setValidators([Validators.required]);
            }
            else {
              this.recipientCtrl.placeholder = MemberIDOfRecipientPlaceholder;
              this.getMemberList();
              if (frmCtrl) frmCtrl.setValidators([Validators.required]);

              this.recipientTitleSection.setShow(false);
              this.recipientTitleCtrl.getFormControl().setValidators([]);
              this.recipientFirstnameCtrl.getFormControl().setValidators([]);
              this.recipientLastnameCtrl.getFormControl().setValidators([]);

              this.recipientTitleCtrl.getFormControl().setValue("");
              this.recipientFirstnameCtrl.getFormControl().setValue("");
              this.recipientLastnameCtrl.getFormControl().setValue("");
            }
          }
          break;
        }
        case AgreeToTerms: {
          break;
        }
      }
    }
    else if (Iceutility.isdefined(event.autocompleteSettings)) {
      switch (event.autocompleteSettings.id) {
        case Recipient: {
          this.doRecipientFromControl();
          break;
        }
      }
    }
  }

  onMatGridColClick(event) {
    if (event.rowData == null) {
      // To do log error
      return;
    }

    this.domainSvc.loadConsentFile(event.rowData.login_user_name, event.rowData.key, event.rowData.external_data_key, IceTypes.SourceType.srcMiscellaneousForms);
  }

  private getRecipientElementValue(): string {
    let ret = "";
    let recipient: FormControl = this.recipientCtrl.getFormControl();
    if (Iceutility.isdefined(recipient)) {
      let recipElem = <HTMLInputElement>document.getElementById(Recipient);
      if (recipElem) {
        if (recipElem.value.length == 0) {
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "Error: Invalid recipient.");
          return ret;
        }
        ret = recipElem.value;
      }
    }
    return ret;
  }

  private sendInvite(acceptrefs: consentreference[]) {
    if (this.invitemsg.message_key == "") {
      this.invitemsg.message_key = Iceutility.guid(false);
      this.invitemsg.message_date = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
      this.invitemsg.message_status = IceTypes.trans_status.isReadyToSend;
      this.invitemsg.trans_type = IceTypes.TRANSTYPE.itInvite;
    }

    let userInfo = this.loginSvc.GetSessionUserInfo();
    if (Iceutility.isdefined(userInfo))
      this.invitemsg.from = userInfo.Username;

    this.invitemsg.CONSENTS = this.invitemsg.CONSENTS.concat(acceptrefs);

    if (<typeOfMember>this.typeOfInviteCtrl.getFormControl().value == typeOfMember.toiNew) {
      this.invitemsg.to = this.getRecipientElementValue();

      // set title, first and last
      let glrule: managementguideline = null;
      let alt: alert = null;
      let mem: user = null;
      if (this.invitemsg.GLRULES.length == 0) {
        glrule = new managementguideline();
        glrule.management_guideline_key = Iceutility.guid(false);
        glrule.title = this.invitemsg.subject;
        glrule.src_type = IceTypes.SourceType.srcUndefined;
        glrule.src_key = "";
        glrule.sub_type = 0;
        glrule.alert_type = IceTypes.ALERTTYPE.alertNotification;
        glrule.ALERTS = [];
        this.invitemsg.GLRULES.push(glrule);
      }
      else {
        glrule = this.invitemsg.GLRULES[0];
      }

      if (glrule.ALERTS.length == 0) {
        alt = new alert();
        alt.alert_key = Iceutility.guid(false);
        alt.title = glrule.title;
        alt.alert_type = IceTypes.ALERTTYPE.alertNotification;
        alt.USERS = [];
        glrule.ALERTS.push(alt);
      }
      else {
        alt = glrule.ALERTS[0];
      }

      if (alt.USERS.length == 0) {
        mem = new user();
        alt.USERS.push(mem);
      }
      else {
        mem = alt.USERS[0];
      }

      mem.email = this.invitemsg.to
      mem.prefix = this.recipientTitleCtrl.getFormControl().value;
      mem.first_name = this.recipientFirstnameCtrl.getFormControl().value;
      mem.last_name = this.recipientLastnameCtrl.getFormControl().value;

      this.messageService.inviteRegister(this.invitemsg).subscribe(data => {
        this.router.navigate([this.navSvc.buildRoute("messages/sent", false)]);
      }, error => {
        console.log(error);
        if (Iceutility.isdefined(error.statusText))
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, error.statusText);
        else
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "Error: failed to send invite.");
      });
    }
    else {
      this.messageService.sendMessage(this.invitemsg, this.navSvc).subscribe(data => {
        this.router.navigate([this.navSvc.buildRoute("messages/sent", false)]);
      }, error => {
        console.log(error);
        if (Iceutility.isdefined(error.statusText))
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, error.statusText);
        else
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "Error: failed to send invite.");
      });
    }
  }

  validateRecipient(): boolean {
    let recipient: FormControl = this.recipientCtrl.getFormControl();

    if (<typeOfMember>this.typeOfInviteCtrl.getFormControl().value == typeOfMember.toiNew
      && Iceutility.isdefined(recipient)) {
      let recipElem = <HTMLInputElement>document.getElementById(Recipient);
      if (Iceutility.isValidEmail(recipElem.value) && recipElem) {
        if (recipElem.value.length > 0) return true;
      }
    } else if (Iceutility.isdefined(recipient) && Iceutility.isdefined(recipient.value) && recipient.value.length > 0) {

      try {
        let selectedRecips = JSON.parse(recipient.value);
        if (selectedRecips == null || selectedRecips.length == 0) {
          this.invitemsg.to = recipient.value; // let's try this recipient
          return true;
        }
        else {
          this.invitemsg.to = "";
          // since a recipient has been selected, make sure the form is valid
          this.panels[0].getForm().markAsPristine();

          // for now let's only allow one recipient
          if (selectedRecips.length > 1) {
            this.messageService.logMessage(IceTypes.LOGTYPE.ltWarning, "Warning: Only one invited recipient is allowed.");
            return false;
          }

          for (let i = 0; i < selectedRecips.length; i++) {
            if (this.invitemsg.to.length > 0) this.invitemsg.to += ",";
            this.invitemsg.to += selectedRecips[i].value;
            return true;
          }

        }
      }
      catch (e) {
        this.messageService.logMessage(IceTypes.LOGTYPE.ltError, e);
      }
    }
    this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "Error: Invalid recipient.");
    return false;
  }

  onSendInvite(event) {
    // Final validation
    if (!this.validateRecipient())
      return;

    // Terms validation
    let acceptedCons: consentreference[] = [];
    if (this.defaultConsents != null) {
      for (let ia = 0; ia < this.consentDataSource.data.length; ia++) {
        if (this.consentDataSource.data[ia].agree == false) {
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "You must accept the terms of use to continue.");
          return;
        }
        let agreedCons: ConsentListObject = this.consentDataSource.data[ia];
        let defCons: consentreference = null;

        let foundDefCons = this.defaultConsents.filter(c => {
          return c.consent_reference_key == agreedCons.key
        });

        if (foundDefCons.length > 0) {
          defCons = foundDefCons[0];
          defCons.login_user_name = agreedCons.login_user_name;
          defCons.full_name = agreedCons.full_name;
          defCons.date_of_consent = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
          defCons.note_status_type = IceTypes.notestatus.statusComplete;
          acceptedCons.push(defCons);
        }
      }
    }

    let ctrSub: FormControl = this.subjectCtrl.getFormControl();
    if (ctrSub != null) this.invitemsg.subject = ctrSub.value;

    let ctrMsg: FormControl = this.messageBodyCtrl.getFormControl();
    if (ctrMsg != null) this.invitemsg.message_body = ctrMsg.value;

    if (this.invitemsg.subject.length == 0 || this.invitemsg.message_body.length == 0) {
      this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "The invite subject and message is required.");
      return;
    }
    if (location.href.indexOf("localhost") >= 0) {
      this.sendInvite(acceptedCons);
      return;
    }

    this.googleService.verifyRecaptcha(this.googleService.recaptchaToken).subscribe(data => {
      this.sendInvite(acceptedCons);
    }, error => {
      console.log(error);
    });
  }

  private getMemberList() {
    this.domainSvc.searchNetworkNow("").subscribe(
      data => {
        if (data && data.length > 0 && data[0] != null) {
          let memObjs: user[] = <user[]>data;
          let opts = memObjs.map(m => { return { value: m.login_user_name, name: m.getdisplayname() } });
          this.recipientCtrl.setOptions(this.recipientCtrl.getOptions().concat(opts));
        }
      },
      error => {
        console.log(JSON.stringify(this.messageService.getLastErrors()));
      });
  }
}
